
import statisticsAPI from "../../../../services/statistics";
import { useAuthContext } from "../../../../hooks/useAuthContext";
import { useEffect, useRef, useState } from "react";
import TodaySessionsComponent from "./TodaySessionsComponent";
import { Dropdown } from "primereact/dropdown";
import sessionsAPI from "../../../../services/sessions";
import { Panel } from "primereact/panel";
import TodayAbsenteesComponent from "./TodayAbsenteesComponent";
import TodayBackAloneComponent from "./TodayBackAloneComponent";
import { Button } from "primereact/button";
import { ConfirmPopup, confirmPopup } from "primereact/confirmpopup";
import { Toast } from "primereact/toast";
import attendancesAPI from "../../../../services/attendances";
import { Calendar } from "primereact/calendar";
import { addLocale } from 'primereact/api';
import useUrlState from "@ahooksjs/use-url-state";
import { useNavigate } from "react-router-dom";
import { ToFormatedShortISODate } from "../../../../utils/dates";
import { PERMISSION_TRAINING_ATTANDANCES, PERMISSION_TRAINING_SESSIONS } from "../../../../permissions";

const TrainingTilesComponent = ({ training }) => {
    const { auth, hasPermission } = useAuthContext();
    const navigate = useNavigate();
    const schoolId = training?.school_id;
    const trainingId = training?.id;
    const accessToken = auth?.accessToken;
    const canViewSessionCards = hasPermission(PERMISSION_TRAINING_SESSIONS.LIST) || hasPermission(PERMISSION_TRAINING_SESSIONS.GET);
    const canCreateAttendances = hasPermission(PERMISSION_TRAINING_ATTANDANCES.CREATE);

    const today = ToFormatedShortISODate(new Date());
    const toShortDay = (value) => (
        typeof value === "string" && value.includes("T") ? ToFormatedShortISODate(new Date(value)) : value
    );
    const [state, setState] = useUrlState({
        sessionsFilter: JSON.stringify({
            slot_id: "",
            level_id: "",
            classe_id: "",
            course_id: "",
            teacher_id: "",
            classroom_id: "",
            day: today,
            start_date: today,
            end_date: today,
        }),
    })

    const [registrationsChartData, setRegistrationsChartData] = useState({});
    const [registrationsChartOptions, setRegistrationsChartOptions] = useState({});
    const registrationsStatsQuery = statisticsAPI.useGetStudentsRegistrationsStats(
        schoolId,
        trainingId,
        accessToken
    );
    const registrationsStats = registrationsStatsQuery.data?.data;
    addLocale('fr', {
        firstDayOfWeek: 1,
        showMonthAfterYear: true,
        dayNames: ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'],
        dayNamesShort: ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'],
        dayNamesMin: ['D', 'L', 'M', 'M', 'J', 'V', 'S'],
        monthNames: ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Aout', 'Septembre', 'Octobre', 'Novembre', 'Décembre'],
        monthNamesShort: ['Jan', 'Feb', 'Mar', 'Avr', 'Mai', 'Juin', 'Juil', 'Aou', 'Sep', 'Oct', 'Nov', 'Déc'],
        today: 'Aujourd\'hui',
        clear: 'Annuler'
    });

    useEffect(() => {
        const documentStyle = getComputedStyle(document.documentElement);
        const data = {
            datasets: [
                {
                    data: [registrationsStats?.new_students_count || 0, registrationsStats?.preregistred_students_count || 0, registrationsStats?.enrolled_students_count || 0, registrationsStats?.waitinglist_students_count || 0, registrationsStats?.unregistred_students_count || 0],
                    backgroundColor: [
                        documentStyle.getPropertyValue('--purple-500'),
                        documentStyle.getPropertyValue('--blue-500'),
                        documentStyle.getPropertyValue('--green-500'),
                        documentStyle.getPropertyValue('--orange-500'),
                        documentStyle.getPropertyValue('--red-500'),
                    ],
                    hoverBackgroundColor: [
                        documentStyle.getPropertyValue('--purple-400'),
                        documentStyle.getPropertyValue('--blue-400'),
                        documentStyle.getPropertyValue('--green-400'),
                        documentStyle.getPropertyValue('--orange-400'),
                        documentStyle.getPropertyValue('--red-400')
                    ]
                }
            ]
        }
        const options = {
            plugins: {
                legend: {
                    labels: {
                        usePointStyle: true
                    }
                }
            }
        };

        setRegistrationsChartData(data);
        setRegistrationsChartOptions(options);
    }, [registrationsStats]);
    const trainingAssetsStatsQuery = statisticsAPI.GetTrainingAssetsStats(
        schoolId,
        trainingId,
        accessToken
    );


    const rawSessionsFilter = JSON.parse(state.sessionsFilter);
    const sessionsFilterObj = {
        ...rawSessionsFilter,
        day: toShortDay(rawSessionsFilter.day),
        start_date: toShortDay(rawSessionsFilter.start_date),
        end_date: toShortDay(rawSessionsFilter.end_date),
    };
    const selectedDay = sessionsFilterObj.day || sessionsFilterObj.start_date;
    const calendarFilterDayValue = (() => {
        if (!selectedDay) {
            return null;
        }
        const [year, month, day] = selectedDay.split("-").map(Number);
        return new Date(year, month - 1, day);
    })();

    const queryList = sessionsAPI.useGetList(
        schoolId,
        trainingId,
        accessToken,
        1,
        100000,
        sessionsFilterObj
    );

    const todaySessions = queryList?.data?.data || [];

    // get slots from todaySessions
    const slots = todaySessions.map(session => session.schedule_item?.slot);
    // get unique slots, slots are defined by their id
    const uniqueSlots = [...new Map(slots.map(slot => [slot.id, slot])).values()];

    const [showedSessions, setShowedSessions] = useState([]);
    const [selectedSlot, setSelectedSlot] = useState("");

    const toast = useRef(null);

    const setFilters = (filters) => {
        let currentFilter = state?.sessionsFilter;
        let currentFilterObj = JSON.parse(currentFilter);
        Object.keys(filters).forEach((key) => {
            currentFilterObj[key] = filters[key];
        });
        setState((s) => ({
            schedulePage: 1,
            sessionsFilter: JSON.stringify(currentFilterObj),
        }));
    };
    //

    useEffect(() => {
        const currentHour = new Date().getHours();
        const findCurrentSlot = () => {
            if (selectedDay !== today) {
                return "";
            }
            for (const slot of uniqueSlots) {
                const [startHour] = slot.start_hour?.split(':').map(Number);
                const [endHour] = slot.end_hour?.split(':').map(Number);
                if
                    ((currentHour >= (startHour - 1)) &&
                    (currentHour < (endHour + 1))) {
                    return slot.id;
                }
            }
            return "";
        };
        const currentSlotId = findCurrentSlot();
        setSelectedSlot(currentSlotId);
    }, [todaySessions]);

    useEffect(() => {
        if (selectedSlot === "") {
            //
            setShowedSessions(todaySessions);
        } else {
            var slotSessions = todaySessions.filter(session => session.schedule_item?.slot?.id === selectedSlot);
            setShowedSessions(slotSessions);
        }
    }, [selectedSlot, todaySessions]);

    const generateAttendences = () => {
        toast.current.show({ severity: 'info', detail: 'Traitement en cours..' });
        let newStatus = "PRESENT";
        attendancesAPI.CreateOne(schoolId, trainingId, accessToken, {
            course_session_ids: showedSessions.map((session) => {
                return session.id;
            }),
            default_status: newStatus,
        }).then((data) => {
            toast.current.show({ severity: 'success', detail: 'Feuilles de présences générées avec succès' });
            queryList.refetch();
        }
        ).catch((error) => {
            toast.current.show({ severity: 'error', detail: 'Erreur lors de la génération des feuilles de présences' });
        })
        // let elements = studentsRef.current.getSelectedElements();
        // tasksAPI.UpdateStudentsResult(schoolId, trainingId, accessToken, {
        //     students_ids: elements?.map((element) => {
        //         return element.id;
        //     }),
        //     new_result: newStatus,
        // }).then((data) => {
        //     setJobId(data?.data?.id);
        // }).catch((error) => {
        //     console.log("error", error);
        // });
    };

    const presenceHeaderTemplate = (options) => {
        const className = `${options.className} justify-content-space-between`;
        return (
            <div className={className}>
                <div className="flex  align-items-center gap-2">
                    <span className="font-bold text-lg">Feuilles de présences</span>
                </div>
                <div className="flex flex-nowrap">
                    {canCreateAttendances && (
                        <Button icon="pi pi-wallet" rounded text className="mr-2"
                            tooltipOptions={{ position: "left" }} tooltip="Générer les feuilles de présence" onClick={(event) => {
                                confirmPopup({
                                    target: event.currentTarget,
                                    message: 'Générer les feuilles de présences?',
                                    icon: 'pi pi-exclamation-triangle',
                                    defaultFocus: 'accept',
                                    acceptLabel: 'Oui',
                                    rejectLabel: 'Non',
                                    accept: () => generateAttendences()
                                });
                            }} />
                    )}
                    {options.togglerElement}
                </div>
            </div>
        );
    };

    const documentsHeaderTemplate = (options) => {
        const className = `${options.className} justify-content-space-between`;
        return (
            <div className={className}>
                <div className="flex  align-items-center gap-2">
                    <span className="font-bold text-lg">Documents</span>
                </div>
                <div className="flex flex-nowrap">
                    <Button icon="pi pi-folder-open" rounded text className="mr-2"
                        tooltipOptions={{ position: "left" }} tooltip="Gérer les documents" onClick={(event) => {
                            navigate("/school/" + schoolId + "/admin/trainings/" + trainingId + "/documents");
                        }} />
                    {options.togglerElement}
                </div>
            </div>
        );
    };

    return (
        <>
            <Toast position="bottom-center" ref={toast} />
            <ConfirmPopup />
            <div className="flex align-items-stretch flex-column  sm:flex-row w-full gap-2 mb-2">
                <Calendar style={{ color: "black" }} locale="fr" showButtonBar dateFormat="D, dd/mm/yy"
                    showWeek={true} showIcon={true} icon={() => <i className="pi pi-calendar text-600" />}
                    value={calendarFilterDayValue}
                    onClearButtonClick={(e) => {
                        setFilters({ day: today, start_date: today, end_date: today });
                    }}
                    onChange={(e) => {
                        const day = e.value ? ToFormatedShortISODate(e.value) : "";
                        setFilters({ day, start_date: day, end_date: day });
                    }} />
                <div className="text-500 font-medium">
                    <Dropdown showClear placeholder="Choisir un créneau" emptyMessage="Pas de créneaux." className="w-full" options={uniqueSlots} optionLabel="name" value={uniqueSlots?.find(
                        (obj) => obj.id === selectedSlot
                    )} onChange={(e) => {
                        setSelectedSlot(e?.value?.id || "");
                    }} />
                </div>
            </div>
            <div className="grid">
                {canViewSessionCards && (
                    <div className="col-12 md:col-6 lg:col-4">
                        <Panel className="h-full  shadow-none" headerTemplate={presenceHeaderTemplate} header="Feuilles de présences" toggleable>
                            <TodaySessionsComponent todaySessions={showedSessions} objectQuery={queryList} schoolId={schoolId} trainingId={trainingId} />
                        </Panel>
                    </div>
                )}

                <div className="col-12 md:col-6 lg:col-4">
                    <Panel className="h-full shadow-none" header="Liste des absents" toggleable>
                        <TodayAbsenteesComponent todaySessions={showedSessions} objectQuery={queryList} schoolId={schoolId} trainingId={trainingId} callback={() => {
                            queryList.refetch();
                        }} />
                    </Panel>

                </div>
                <div className="col-12 md:col-6 lg:col-4">
                    <Panel className="h-full shadow-none" header="Autorisés à partir seuls" toggleable>
                        <TodayBackAloneComponent todaySessions={showedSessions} objectQuery={queryList} schoolId={schoolId} trainingId={trainingId} />
                    </Panel>

                </div>
            </div>
            {/* 
            <div className="grid mt-1">
                <div className="col-12 md:col-6 lg:col-4">
                    <Panel className="h-full shadow-none" headerTemplate={documentsHeaderTemplate} header="Documents" toggleable>
                        <DocumentsListComponent
                            //ref={listRef}
                            showAddButton={false}
                            showFilterButton={false}
                            selectedFields={{
                                select: false,
                                name: true,
                                presentation: false,
                                edit: false,
                            }}
                        />
                    </Panel>
                </div>

                <div className="col-12 md:col-6 lg:col-4">
                    <Panel className="h-full shadow-none" header="Inscriptions" toggleable>
                        <div className="flex justify-content-between mb-3 border-bottom-1 border-300">
                            <div>

                                <div className="text-green-500 font-medium">Ouverte</div>
                                <div>
                                    <span className="text-500">De: {training?.start_registration_date ? new Date(training?.start_registration_date).toLocaleDateString("fr-FR") : "-"} à {training?.end_registration_date ? new Date(training?.end_registration_date).toLocaleDateString("fr-FR") : "-"}</span>
                                </div>
                            </div>

                        </div>
                        <MeaLink to={"/school/" + training?.school_id + "/admin/trainings/" + training?.id + '/registrations?registrationsFilter=%7B"level_id"%3A""%2C"classe_id"%3A""%2C"name"%3A""%2C"status"%3A"NEW"%2C"registration_new"%3A""%7D'} permission={PERMISSION_SCHOOL_TRAININGS.GET} isRipple={true} >
                            <span className="text-purple-500 font-medium">{registrationsStats?.new_students_count || "0"}  </span>
                            <span className="text-500 ml-1">candidatures</span>
                        </MeaLink>
                        <MeaLink to={"/school/" + training?.school_id + "/admin/trainings/" + training?.id + '/registrations?registrationsFilter=%7B"level_id"%3A""%2C"classe_id"%3A""%2C"name"%3A""%2C"status"%3A"PREREGISTRED"%2C"registration_new"%3A""%7D'} permission={PERMISSION_SCHOOL_TRAININGS.GET} isRipple={true} >
                            <span className="text-blue-500 font-medium">{registrationsStats?.preregistred_students_count || "0"}  </span>
                            <span className="text-500 ml-1">pré-inscriptions</span>
                        </MeaLink>
                        <MeaLink to={"/school/" + training?.school_id + "/admin/trainings/" + training?.id + '/registrations?registrationsFilter=%7B"level_id"%3A""%2C"classe_id"%3A""%2C"name"%3A""%2C"status"%3A"ENROLLED"%2C"registration_new"%3A""%7D'} permission={PERMISSION_SCHOOL_TRAININGS.GET} isRipple={true} >
                            <span className="text-green-500 font-medium">{registrationsStats?.enrolled_students_count || "0"}  </span>
                            <span className="text-500 ml-1">inscriptions confirmés</span>
                        </MeaLink>
                        <MeaLink to={"/school/" + training?.school_id + "/admin/trainings/" + training?.id + '/registrations?registrationsFilter=%7B"level_id"%3A""%2C"classe_id"%3A""%2C"name"%3A""%2C"status"%3A"WAITING_LIST"%2C"registration_new"%3A""%7D'} permission={PERMISSION_SCHOOL_TRAININGS.GET} isRipple={true} >
                            <span className="text-orange-500 font-medium">{registrationsStats?.waitinglist_students_count || "0"}  </span>
                            <span className="text-500 ml-1">en liste d'attente</span>
                        </MeaLink>
                        <MeaLink to={"/school/" + training?.school_id + "/admin/trainings/" + training?.id + '/registrations?registrationsFilter=%7B"level_id"%3A""%2C"classe_id"%3A""%2C"name"%3A""%2C"status"%3A"UNREGISTRED"%2C"registration_new"%3A""%7D'} permission={PERMISSION_SCHOOL_TRAININGS.GET} isRipple={true} >
                            <span className="text-red-500 font-medium">{registrationsStats?.unregistred_students_count || "0"}  </span>
                            <span className="text-500 ml-1">désinscrits</span>
                        </MeaLink>
                        <div className="flex justify-content-center">
                            <Chart type="pie" data={registrationsChartData} options={registrationsChartOptions} className="w-10rem" />
                        </div>
                    </Panel>
                </div>
                <div className="col-12 md:col-6 lg:col-4">
                    <Panel className="h-full shadow-none" header="Statistiques" toggleable>
                        <MeaLink to={"/school/" + training?.school_id + "/admin/trainings/" + training?.id + "/classrooms"} permission={PERMISSION_SCHOOL_TRAININGS.GET} isRipple={true} >
                            <span className="text-green-500 font-medium">{trainingAssetsStats?.classrooms_count || "0"} </span>
                            <span className="text-500 ml-1">salles</span>
                        </MeaLink>
                        <MeaLink to={"/school/" + training?.school_id + "/admin/trainings/" + training?.id + "/slots"} permission={PERMISSION_SCHOOL_TRAININGS.GET} isRipple={true} >
                            <span className="text-green-500 font-medium">{trainingAssetsStats?.slots_count || "0"} </span>
                            <span className="text-500 ml-1">créneaux</span>
                        </MeaLink>
                        <MeaLink to={"/school/" + training?.school_id + "/admin/trainings/" + training?.id + "/levels"} permission={PERMISSION_SCHOOL_TRAININGS.GET} isRipple={true} >
                            <span className="text-green-500 font-medium">{trainingAssetsStats?.levels_count || "0"} </span>
                            <span className="text-500 ml-1">niveaux</span>
                        </MeaLink>
                        <MeaLink to={"/school/" + training?.school_id + "/admin/trainings/" + training?.id + "/courses"} permission={PERMISSION_SCHOOL_TRAININGS.GET} isRipple={true} >
                            <span className="text-green-500 font-medium">{trainingAssetsStats?.courses_count || "0"} </span>
                            <span className="text-500 ml-1">matières</span>
                        </MeaLink>
                        <MeaLink to={"/school/" + training?.school_id + "/admin/trainings/" + training?.id + "/classes"} permission={PERMISSION_SCHOOL_TRAININGS.GET} isRipple={true} >
                            <span className="text-green-500 font-medium">{trainingAssetsStats?.classes_count || "0"} </span>
                            <span className="text-500 ml-1">classes</span>
                        </MeaLink>
                        <MeaLink to={"/school/" + training?.school_id + "/admin/trainings/" + training?.id + "/teachers"} permission={PERMISSION_SCHOOL_TRAININGS.GET} isRipple={true} >
                            <span className="text-green-500 font-medium">{trainingAssetsStats?.teachers_count || "0"} </span>
                            <span className="text-500 ml-1">enseignant(e)s</span>
                        </MeaLink>
                        <MeaLink to={"/school/" + training?.school_id + "/admin/trainings/" + training?.id + "/students"} permission={PERMISSION_SCHOOL_TRAININGS.GET} isRipple={true} >
                            <span className="text-green-500 font-medium">{trainingAssetsStats?.students_count || "0"} </span>
                            <span className="text-500 ml-1">élèves confirmés</span>
                        </MeaLink>
                    </Panel>

                </div>
            </div>*/}
        </>
    )
};

export default TrainingTilesComponent;